import React from 'react';
import { Play } from 'lucide-react';

const FeaturedWork = () => {
  const works = [
    {
      id: 1,
      title: 'Masicka Shuts Down Miami 🔥 Live at One Link 2025',
      category: 'Events',
      videoId: '2LWwfOORf2I',
      youtubeUrl: 'https://www.youtube.com/watch?v=2LWwfOORf2I'
    },
    {
      id: 2,
      title: 'The Two Russells Podcast Ep 44: Gareth Samples, CEO',
      category: 'Podcasts',
      videoId: 'AKoYXLKjJ3s',
      youtubeUrl: 'https://www.youtube.com/watch?v=AKoYXLKjJ3s'
    },
    {
      id: 3,
      title: 'The Man Who Invented Baileys | Creativity & Golden Age of Advertising',
      category: 'Brand Content',
      videoId: 'NYAwfRxZw3k',
      youtubeUrl: 'https://www.youtube.com/watch?v=NYAwfRxZw3k&t=1368s'
    },
    {
      id: 4,
      title: 'Ahmed Khan: How I Bought 16 Houses By 29 | PBK Podcast',
      category: 'Podcasts',
      videoId: 'uBkxSb5Rj18',
      youtubeUrl: 'https://www.youtube.com/watch?v=uBkxSb5Rj18&t=685s'
    }
  ];

  return (
    <section id="featured-work" className="relative z-10 py-24 sm:py-32 border-t border-white/[0.06] bg-white/[0.015]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="mb-14 sm:mb-20">
          <p className="ltv-eyebrow text-red-500 mb-4">05 — Portfolio</p>
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold text-white leading-[1.05]">
            Featured
            <span className="text-gray-500"> work.</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5">
          {works.map((work) => (
            <div key={work.id} className="group rounded-2xl overflow-hidden border border-white/[0.08] bg-white/[0.03] hover:bg-white/[0.06] hover:border-white/20 transition-all duration-500">
              <div className="relative aspect-video overflow-hidden bg-black">
                <iframe
                  src={`https://www.youtube.com/embed/${work.videoId}`}
                  title={work.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full h-full"
                ></iframe>
              </div>
              <a href={work.youtubeUrl} target="_blank" rel="noopener noreferrer" className="block p-6 sm:p-7">
                <p className="flex items-center gap-2 mb-3">
                  <Play className="h-3.5 w-3.5 text-red-500 fill-red-500" />
                  <span className="ltv-eyebrow text-red-500">{work.category}</span>
                </p>
                <h3 className="font-display text-lg font-bold leading-tight text-white group-hover:text-red-400 transition-colors duration-300">
                  {work.title}
                </h3>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedWork;
